<template>
  <abf-container>
    <v-layout wrap>
      <v-flex xs12 md5>
        <v-card class="pa-2">
          <v-card-title class="pb-0 mb-0">
            <v-avatar class="secondary">
              <v-icon dark>create</v-icon>
            </v-avatar>
            <div class="ml-3">
              <h4 class="headline">Content</h4>
            </div>
          </v-card-title>
          <v-form lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field label="Web Link" placeholder="https://..." v-model="updates.web_link"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-subheader class="pa-0">Web Content</v-subheader>
                  <vue-editor id="web" v-model="updates.web_content" :editorToolbar="toolbarOptions"></vue-editor>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-card-actions class="justify-space-between">
            <v-switch
              class="mt-0"
              v-model="updates.show_web_content"
              label="Show web content"
              :hide-details="true"
            ></v-switch>
            <v-btn color="accent" @click="updatePartner">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 md7>
        <v-card class="pa-2">
          <v-card-title class="pb-0 mb-0">
            <v-avatar class="secondary">
              <v-icon dark>pageview</v-icon>
            </v-avatar>
            <div class="ml-3">
              <h4 class="headline">Website Preview</h4>
            </div>
          </v-card-title>
          <v-card-text>
            <v-layout>
              <v-flex>
                <img :src="SelectedPartner.logo" alt="" style="width: 190px; height: auto;" />
              </v-flex>
              <v-flex>
                <h2>{{ SelectedPartner.name }}</h2>
                <span class="partner-web-content" v-html="updates.web_content"></span>
                <p>
                  <a class="accent updates-link" :href="updates.web_link" target="_blank" title="Find out more"
                    >VISIT PARTNER</a
                  >
                </p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </abf-container>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import { mapActions, mapGetters } from 'vuex';
import AbfContainer from '../../Abf/AbfContainer';
import { toolbarOptions } from '@/utils/vueEditorConfig';

export default {
  components: {
    AbfContainer,
    VueEditor
  },
  name: 'partner-web-content',
  data: () => ({
    updates: {
      web_content: null,
      web_link: null,
      show_web_content: false
    },
    toolbarOptions
  }),
  computed: {
    ...mapGetters(['SelectedPartner'])
  },
  methods: {
    ...mapActions(['updateSelectedPartner', 'addNotification']),
    updatePartner: function() {
      this.updateSelectedPartner(this.updates).then(() => {
        this.addNotification({
          text: `${this.SelectedPartner.name} web content updated`
        });
      });
    }
  },
  watch: {
    SelectedPartner: {
      immediate: true,
      handler() {
        this.updates.web_link = this.SelectedPartner.web_link;
        this.updates.web_content = this.SelectedPartner.web_content;
        this.updates.show_web_content = this.SelectedPartner.show_web_content;
      }
    }
  }
};
</script>

<style scoped>
.updates-link {
  background-color: #89c731;
  border-radius: 3px;
  color: #ffffff;
  display: inline-block;
  font-size: 14px;
  letter-spacing: normal;
  line-height: 100%;
  padding: 10px;
  text-align: center;
  text-decoration: none;
}
</style>
